import React, { useEffect, useState } from 'react';
import { browserHistory } from 'react-router';
import Header from '../../../components/Header.js';
import withUser from '../../../common/withUser.js';
import Bugsnag from '../../../helpers/bugsnag.js';
import withLoader from '../../../common/withLoader.js';
import withSetsToMove from '../../../common/withSetsToMove.js';
import OptimizeModal from '../../../components/commonComponents/OptimizeModal.js';
import { getSetMoveLocations, updateSetsStatus } from '../../../utils/utils.js';
import withNotify from '../../../common/withNotify.js';
import { sortData } from '../../../common/globals.js';
import withGoBack from '../../../common/withGoBack';

function MoveToLocation(props) {
  const [locations, setLocations] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);

  useEffect(() => {
    document.body.classList.remove('modal-open');
    const modalBackdrop = document.querySelector('.modal-backdrop');
    if (modalBackdrop) {
      modalBackdrop.remove();
    }

    try {
      const { setLoader, notify } = props;
      setLoader(true);
      const setLocationsData = async () => {
        const locationsRes = await getSetMoveLocations();
        if (!locationsRes.data) {
          notify({ type: 'error', message: 'There are no locations to show.' });
          return;
        }
        const locationsList = locationsRes.data.map((loc) => ({
          LocNo: loc.CustomerNo,
          LocName: loc.CustomerName,
          LocAbb: loc.CustomerAbb,
        }));
        const officeLocation = locationsList.find((loc) => loc.LocName.toUpperCase().includes('OFFICE'));
        const sortedLocations = sortData(locationsList, 'LocName')
          .filter((loc) => loc.LocName !== officeLocation.LocName);
        setLocations([officeLocation, ...sortedLocations]);
      };
      setLocationsData().finally(() => setLoader(false));
    } catch (error) {
      Bugsnag.notify(error);
    }
  }, []);

  const onSelectLocation = async (location) => {
    try {
      const { setsToMove, notify, setLoader } = props;
      if (!setsToMove || setsToMove.length === 0) {
        notify({ type: 'error', message: 'No sets to move' });
        browserHistory.goBack();
        return;
      }
      setLoader(true);
      setSelectedLocation(location);
      const res = await updateSetsStatus({
        SetID: setsToMove.map((set) => set.ID),
        LocNo: location.LocNo,
        LocName: location.LocName,
        LocAbb: location.LocAbb
      }).finally(() => setLoader(false));
      if (res.result === 'success') {
        setShowModal(true);
      } else {
        notify({ type: 'error', message: res.message });
      }
    } catch (error) {
      Bugsnag.notify(error);
    }
  };

  const onGoBack = () => {
    const { setGoBack, goBack } = props;
    if (goBack) {
      const lastRoute = goBack.pop();
      setGoBack([...goBack]);
      browserHistory.push(lastRoute);
    }
  };

  return (
    <div>
      <OptimizeModal
        id="MoveToLocationModal"
        onClose={onGoBack}
        modalBody={
          props.setsToMove && selectedLocation ? (
            <p>
              {props.setsToMove.length} {props.setsToMove.length > 1 ? 'sets' : 'set'} moved to {selectedLocation.LocName}
            </p>
          ) : null
        }
        modalFooter={(
          <div className="row gx-2">
            <div className="col-12">
              <button
                type="button"
                className="btn btn-link w-100"
                onClick={() => {
                  setShowModal(false);
                }}
              >OK
              </button>
            </div>
          </div>
        )}
        show={showModal}
      />
      <Header
        title="Move To Location"
        goBack={() => browserHistory.goBack()}
      />
      <div className="container">
        <ul className="select-list list-unstyled cursor-pointer">
          {
              locations.map((location) => (
                <a
                  key={location.LocName}
                  role="button"
                  tabIndex={0}
                  onClick={() => onSelectLocation(location)}
                >
                  <li
                    style={{
                      padding: '15px 0',
                    }}
                  >
                    <p style={{ margin: 0, fontWeight: '600' }}>
                      {location.LocName}
                    </p>
                  </li>
                </a>
              ))
          }
        </ul>
      </div>
    </div>
  );
}

export default withNotify(withSetsToMove(withLoader(withUser(withGoBack(MoveToLocation)))));
